import { render, staticRenderFns } from "./ConstructionSafetyQA.vue?vue&type=template&id=8c3ea0ea&scoped=true"
import script from "./ConstructionSafetyQA.vue?vue&type=script&lang=js"
export * from "./ConstructionSafetyQA.vue?vue&type=script&lang=js"
import style0 from "./ConstructionSafetyQA.vue?vue&type=style&index=0&id=8c3ea0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3ea0ea",
  null
  
)

export default component.exports